<i class="fs-16px" [ngClass]="iconColorClass" [uiType]="iconType" [uiTheme]="iconTheme" ui-icon></i>
